export const regionsData = {
  "RU-*": "Вся Россия",
  "RU-MOW": "Москва",
  "RU-SPE": "Санкт-Петербург",
  "RU-AD": "Республика Адыгея (Адыгея)",
  "RU-AL": "Республика Алтай",
  "RU-BA": "Республика Башкортостан",
  "RU-BU": "Республика Бурятия",
  "RU-DA": "Республика Дагестан",
  "UA-14": "Донецкая Народная Республика",
  "RU-IN": "Республика Ингушетия",
  "RU-KB": "Кабардино-Балкарская Республика",
  "RU-KL": "Республика Калмыкия",
  "RU-KC": "Карачаево-Черкесская Республика",
  "RU-KR": "Республика Карелия",
  "RU-KO": "Республика Коми",
  "UA-43": "Республика Крым",
  "UA-09": "Луганская Народная Республика",
  "RU-ME": "Республика Марий Эл",
  "RU-MO": "Республика Мордовия",
  "RU-SA": "Республика Саха (Якутия)",
  "RU-SE": "Республика Северная Осетия — Алания",
  "RU-TA": "Республика Татарстан (Татарстан)",
  "RU-TY": "Республика Тыва",
  "RU-UD": "Удмуртская Республика",
  "RU-KK": "Республика Хакасия",
  "RU-CE": "Чеченская Республика",
  "RU-CU": "Чувашская Республика — Чувашия",
  "RU-ALT": "Алтайский край",
  "RU-ZAB": "Забайкальский край",
  "RU-KAM": "Камчатский край",
  "RU-KDA": "Краснодарский край",
  "RU-KYA": "Красноярский край",
  "RU-PER": "Пермский край",
  "RU-PRI": "Приморский край",
  "RU-STA": "Ставропольский край",
  "RU-KHA": "Хабаровский край",
  "RU-AMU": "Амурская область",
  "RU-ARK": "Архангельская область",
  "RU-AST": "Астраханская область",
  "RU-BEL": "Белгородская область",
  "RU-BRY": "Брянская область",
  "RU-VLA": "Владимирская область",
  "RU-VGG": "Волгоградская область",
  "RU-VLG": "Вологодская область",
  "RU-VOR": "Воронежская область",
  "UA-23": "Запорожская область",
  "RU-IVA": "Ивановская область",
  "RU-IRK": "Иркутская область",
  "RU-KGD": "Калининградская область",
  "RU-KLU": "Калужская область",
  "RU-KEM": "Кемеровская область — Кузбасс",
  "RU-KIR": "Кировская область",
  "RU-KOS": "Костромская область",
  "RU-KGN": "Курганская область",
  "RU-KRS": "Курская область",
  "RU-LEN": "Ленинградская область",
  "RU-LIP": "Липецкая область",
  "RU-MAG": "Магаданская область",
  "RU-MOS": "Московская область",
  "RU-MUR": "Мурманская область",
  "RU-NIZ": "Нижегородская область",
  "RU-NGR": "Новгородская область",
  "RU-NVS": "Новосибирская область",
  "RU-OMS": "Омская область",
  "RU-ORE": "Оренбургская область",
  "RU-ORL": "Орловская область",
  "RU-PNZ": "Пензенская область",
  "RU-PSK": "Псковская область",
  "RU-ROS": "Ростовская область",
  "RU-RYA": "Рязанская область",
  "RU-SAM": "Самарская область",
  "RU-SAR": "Саратовская область",
  "RU-SAK": "Сахалинская область",
  "RU-SVE": "Свердловская область",
  "RU-SMO": "Смоленская область",
  "RU-TAM": "Тамбовская область",
  "RU-TVE": "Тверская область",
  "RU-TOM": "Томская область",
  "RU-TUL": "Тульская область",
  "RU-TYU": "Тюменская область",
  "RU-ULY": "Ульяновская область",
  "UA-65": "Херсонская область",
  "RU-CHE": "Челябинская область",
  "RU-YAR": "Ярославская область",
  "UA-40": "Севастополь",
  "RU-YEV": "Еврейская автономная область",
  "RU-NEN": "Ненецкий автономный округ",
  "RU-KHM": "Ханты-Мансийский автономный округ — Югра",
  "RU-CHU": "Чукотский автономный округ",
  "RU-YAN": "Ямало-Ненецкий автономный округ",
  "KZ-BAY": "Байконур",
  "UA-63": "Харьковская область"
}

export const citiesData = {
  "Moscow": "Москва",
  "St Petersburg": "Санкт-Петербург",
  "Novosibirsk": "Новосибирск",
  "Yekaterinburg": "Екатеринбург",
  "Krasnodar": "Краснодар",
  "Samara": "Самара",
  "Chelyabinsk": "Челябинск",
  "Kazan'": "Казань",
  "Khabarovsk": "Хабаровск",
  "Ufa": "Уфа",
  "Nizhniy Novgorod": "Нижний Новгород",
  "Voronezh": "Воронеж",
  "Perm": "Пермь",
  "Krasnoyarsk": "Красноярск",
  "Kostroma": "Кострома",
  "Chita": "Чита",
  "Yakutsk": "Якутск",
  "Omsk": "Омск",
  "Irkutsk": "Иркутск",
  "Rostov-on-Don": "Ростов-на-Дону",
  "Vladivostok": "Владивосток",
  "Saratov": "Саратов",
  "Tolyatti": "Тольятти",
  "Tomsk": "Томск",
  "Tyumen": "Тюмень",
  "Volgograd": "Волгоград",
  "Stavropol": "Ставрополь",
  "Barnaul": "Барнаул",
  "Izhevsk": "Ижевск",
  "Tula": "Тула",
  "Ryazan": "Рязань",
  "Ulyanovsk": "Ульяновск",
  "Bryansk": "Брянск",
  "Orenburg": "Оренбург",
  "Surgut": "Сургут",
  "Lipetsk": "Липецк",
  "Yaroslavl": "Ярославль",
  "Kaliningrad": "Калининград",
  "Kemerovo": "Кемерово",
  "Makhachkala": "Махачкала",
  "Sochi": "Сочи",
  "Ulan-Ude": "Улан-Удэ",
  "Naberezhnyye Chelny": "Набережные Челны",
  "Blagoveshchensk": "Благовещенск",
  "Novokuznetsk": "Новокузнецк",
  "Penza": "Пенза",
  "Tver": "Тверь",
  "Ivanovo": "Иваново",
  "Kaluga": "Калуга",
  "Kurgan": "Курган",
  "Vladikavkaz": "Владикавказ",
  "Cherepovets": "Череповец",
  "Tambov": "Тамбов",
  "Arkhangelsk": "Архангельск",
  "Kursk": "Курск",
  "Balashikha": "Балашиха",
  "Vologda": "Вологда",
  "Nizhnekamsk": "Нижнекамск",
  "Astrakhan": "Астрахань",
  "Domodedovo": "Домодедово",
  "Vladimir": "Владимир",
  "Cheboksary": "Чебоксары",
  "Orekhovo-Zuyevo": "Орехово-Зуево",
  "Murmansk": "Мурманск",
  "Kirov": "Киров",
  "Nakhodka": "Находка",
  "Belgorod": "Белгород",
  "Yuzhno-Sakhalinsk": "Южно-Сахалинск",
  "Oryol": "Орёл",
  "Noril'sk": "Норильск",
  "Syktyvkar": "Сыктывкар",
  "Grozny": "Грозный",
  "Noginsk": "Ногинск",
  "Shchyolkovo": "Щёлково",
  "Severodvinsk": "Северодвинск",
  "Komsomolsk-on-Amur": "Комсомольск-на-Амуре",
  "Biysk": "Бийск",
  "Pskov": "Псков",
  "Abakan": "Абакан",
  "Krasnogorsk": "Красногорск",
  "Kyzyl": "Кызыл",
  "Nizhny Tagil": "Нижний Тагил",
  "Angarsk": "Ангарск",
  "Bratsk": "Братск",
  "Buynaksk": "Буйнакск",
  "Smolensk": "Смоленск",
  "Zlatoust": "Златоуст",
  "Magnitogorsk": "Магнитогорск",
  "Yoshkar-Ola": "Йошкар-Ола",
  "Sterlitamak": "Стерлитамак",
  "Zima": "Зима",
  "Saransk": "Саранск",
  "Neftekamsk": "Нефтекамск",
  "Petropavlovsk-Kamchatsky": "Петропавловск-Камчатский",
  "Staryye Mataki": "Старые Матаки",
  "Reutov": "Реутов",
  "Taganrog": "Таганрог",
  "Aleksandrov": "Александров",
  "Kizlyar": "Кизляр",
  "Ust'-Ilimsk": "Усть-Илимск",
  "Ramenskoye": "Раменское",
  "Kamensk-Uralsky": "Каменск-Уральский",
  "Nevel": "Невель",
  "Yelizovo": "Елизово",
  "Volzhsky": "Волжский",
  "Bezhetsk": "Бежецк",
  "Sergiyev Posad": "Сергиев Посад",
  "Seversk": "Северск",
  "Mytishchi": "Мытищи",
  "Lyubertsy": "Люберцы",
  "Belovo": "Белово",
  "Vorkuta": "Воркута",
  "Pushkino": "Пушкино",
  "Novokuybyshevsk": "Новокуйбышевск",
  "Nizhnevartovsk": "Нижневартовск",
  "Otradnoye": "Отрадное",
  "Mochishche": "Мочищи",
  "Berdsk": "Бердск",
  "Dolgoprudny": "Долгопрудный",
  "Voskresensk": "Воскресенск",
  "Nefteyugansk": "Нефтеюганск",
  "Kanevskaya": "Каневская",
  "Stary Oskol": "Старый Оскол",
  "Veliky Novgorod": "Великий Новгород",
  "Nal'chik": "Нальчик",
  "Novocheboksarsk": "Новочебоксарск",
  "Karpinsk": "Карпинск",
  "Engel's": "Энгельс",
  "Kolomna": "Коломна",
  "Osipovka Luka": "Лука Осиповка",
  "Elista": "Элиста",
  "Dubna": "Дубна",
  "Korolyov": "Королёв",
  "Novocherkassk": "Новочеркасск",
  "Votkinsk": "Воткинск",
  "Obninsk": "Обнинск",
  "Leninogorsk": "Лениногорск",
  "Gorno-Altaysk": "Горно-Алтайск",
  "Volgodonsk": "Волгодонск",
  "Ussuriysk": "Уссурийск",
  "Berezniki": "Березники",
  "Pyatigorsk": "Пятигорск",
  "Kaspiysk": "Каспийск",
  "Tikhoretsk": "Тихорецк",
  "Krasnoznamensk": "Краснознаменск",
  "Pudomyagi": "Пудомяги",
  "Sosnovoborsk": "Сосновоборск",
  "Yablonitsy": "Яблоницы",
  "Rezh": "Реж",
  "Petrovsko-Razumovskoye": "Петровско-Разумовское",
  "Asino": "Асиново",
  "Snezhinsk": "Снежинск",
  "Mezhdurechensk": "Междуреченск",
  "Pavlovskiy Posad": "Павловский Посад",
  "Miass": "Миасс",
  "Lobnya": "Лобня",
  "Anapa": "Анапа",
  "Novy Urengoy": "Новый Уренгой",
  "Uzlovaya": "Узловая",
  "Kumertau": "Кумертау",
  "Moscow Oblast": "Московская область",
  "Pervouralsk": "Первоуральск",
  "Kamyshin": "Камышин",
  "Shakhty": "Шахты",
  "Tuymazy": "Туймазы",
  "Shadrinsk": "Шадринск",
  "Vlasikha": "Власиха",
  "Yelets": "Елец",
  "Krasnoobsk": "Краснообск",
  "Maykop": "Майкоп",
  "Khasavyurt": "Хасавюрт",
  "Bagayevskaya": "Багаевская",
  "Derbent": "Дербент",
  "Anapskaya": "Анапская",
  "Bogoroditsk": "Богородицк",
  "Partizansk": "Партизанск",
  "Arzamas": "Арзамас",
  "Rikasovo": "Рикасово",
  "Nazarovo": "Назарово",
  "Gubkin": "Губкин",
  "Prokopyevsk": "Прокопьевск",
  "Murino": "Мурино",
  "Kamensk-Shakhtinsky": "Каменск-Шахтинский",
  "Ukhta": "Ухта",
  "Dmitrov": "Дмитров",
  
  "Novorossiysk": "Новороссийск",
  "Kemsiyurt": "Кемсиюрт",
  "Gornozavodsk": "Горнозаводск",
  "Bor": "Бор",
  "Serpukhov": "Серпухов",
  "Mozhaysk": "Можайск",
  "Losino-Petrovskiy": "Лосино-Петровский",
  "Aksay": "Аксай",
  "Zhukovsky": "Жуковский",
  "Novaya Igirma": "Новая Игирма",
  "Glazov": "Глазов",
  "Sorsk": "Сорск",
  "Poronaysk": "Поронайск",
  "Chernogorsk": "Черногорск",
  "Kandalaksha": "Кандалакша",
  "Balakovo": "Балаково",
  "Kovrov": "Ковров",
  "Tikhvin": "Тихвин",
  "Kansk": "Канск",
  "Megion": "Мегион",
  "Staraya Vichuga": "Старая Вичуга",
  "Kochenevo": "Коченёво",
  "Skopin": "Скопин",
  "Morshansk": "Моршанск",
  "Oktyabrsky": "Октябрьский",
  "Ozersk": "Озёрск",
  "Nekrasovka": "Некрасовка",
  "Uglich": "Углич",
  "Livny": "Ливны",
  "Kingisepp": "Кингисепп",
  "Taldom": "Талдом",
  "Vol'ginskiy": "Вольгинский",
  "Novoural'sk": "Новоуральск",
  "Klin": "Клин",
  "Asbest": "Асбест",
  "Kuybyshev": "Куйбышев",
  "Bisert'": "Бисерть",
  "Lugovskiy": "Луговский",
  "Lukhovitsy": "Луховицы",
  "Petrozavodsk": "Петрозаводск",
  "Aznakayevo": "Азнакаево",
  "Shumerlya": "Шумерля",
  "Armavir": "Армавир",
  "Borisoglebsk": "Борисоглебск",
  "Kirishi": "Кириши",
  "Vanzetur": "Ванзетур",
  "Volokonovka": "Волоконовка",
  "Solikamsk": "Соликамск",
  "Kalikino": "Каликино",
  "Enem": "Энем",
  "Podolsk": "Подольск",
  "Shalya": "Шаля",
  "Severobaykal'sk": "Северобайкальск",
  "Mayya": "Майя",
  "Beloretsk": "Белорецк",
  "Zavodoukovsk": "Заводоуковск",
  "Safonovo": "Сафоново",
  "Avtovo": "Автово",
  "Sasovo": "Сасово",
  "Kislovodsk": "Кисловодск",
  "Shakhtersk": "Шахтёрск",
  "Yugorsk": "Югорск",
  "Kartaly": "Карталы",
  "Lyubim": "Любим",
  "Sarmakovo": "Сармаково",
  "Al'met'yevsk": "Альметьевск",
  "Yemanzhelinsk": "Еманжелинск",
  "Kirsanov": "Кирсанов",
  "Privol'noye": "Привольное",
  "Lesnoy": "Лесной",
  "Kiselevsk": "Киселёвск",
  "Troitsko-Pechorsk": "Троицко-Печорск",
  "Usinsk": "Усинск",
  "Slyudyanka": "Слюдянка",
  "Nazran": "Назрань",
  "Zagoryanskiy": "Загорянский",
  "Ust'-Katav": "Усть-Катав",
  "Sokol": "Сокол",
  "Presnenskiy": "Пресненский",
  "Solnechnogorsk": "Солнечногорск",
  "Dyurtyuli": "Дюртюли",
  "Sayanskoye": "Саянское",
  "Kubinka": "Кубинка",
  "Zelenograd": "Зеленоград",
  "Leninsk-Kuznetsky": "Ленинск-Кузнецкий",
  "Luchegorsk": "Лучегорск",
  "Ishimbay": "Ишимбай",
  "Stroitel": "Строитель",
  "Monino": "Монино",
  "Nelidovo": "Нелидово",
  "Tayshet": "Тайшет",
  "Zheleznogorsk": "Железногорск",
  "Tuchkovo": "Тучково",
  "Gornopravdinsk": "Горноправдинск",
  "Rzhev": "Ржев",
  "Dzerzhinsk": "Дзержинск",
  "Kem'": "Кемь",
  "Vyborg": "Выборг",
  "Shatura": "Шатура",
  "Shelekhov": "Шелехов",
  "Bryukhovetskaya": "Брюховецкая",
  "Kamen'-na-Obi": "Камень-на-Оби",
  "Gubina": "Губино",
  "Trubchevsk": "Трубчевск",
  "Segezha": "Сегежа",
  "Luga": "Луга",
  "Berezovskiy": "Берёзовский",
  "Usolye-Sibirskoye": "Усолье-Сибирское",
  
  "Svobodnyy": "Свободный",
  "Yel'nya": "Ельня",
  "Rostov": "Ростов",
  "Aginskoye": "Агинское",
  "Aleksandrovka": "Александровка",
  "Nevinnomyssk": "Невинномысск",
  "Zaprudnya": "Запрудня",
  "Ardatov": "Ардатов",
  "Kanashevo": "Канашево",
  "Balezino": "Балезино",
  "Yessentuki": "Ессентуки",
  "Torzhok": "Торжок",
  "Azov": "Азов",
  "Veydelevka": "Вейделевка",
  "Berezovka": "Берёзовка",
  "Magadan": "Магадан",
  "Uyar": "Уяр",
  "Kizilyurt": "Кизилюрт",
  "Okha": "Оха",
  "Kholmsk": "Холмск",
  "Orsk": "Орск",
  "Povarovo": "Поварово",
  "Krasnotur'insk": "Краснотурьинск",
  "Fryazino": "Фрязино",
  "Korsakov": "Корсаков",
  "Nev'yansk": "Невьянск",
  "Cheremkhovo": "Черемхово",
  "Salekhard": "Салехард",
  "Beloyarskiy": "Белоярский",
  "Amursk": "Амурск",
  "Zarinsk": "Заринск",
  "Labuya": "Лабуя",
  "Pravdinsk": "Правдинск",
  "Yemel'yanovo": "Емельяново",
  "Novaya Adygeya": "Новая Адыгея",
  "Kudymkar": "Кудымкар",
  "Temryuk": "Темрюк",
  "Tarusa": "Таруса",
  "Shigony": "Шигоны",
  "Chishmy": "Чишмы",
  "Chunskiy": "Чунский",
  "Shepsi": "Шепси",
  "Zheleznodorozhnyy": "Железнодорожный",
  "Nevel'sk": "Невельск",
  "Rostov Oblast": "Ростовская область",
  "Tulun": "Тулун",
  "Yablonovsky": "Яблоновский",
  "Alexeyevka": "Алексеевка",
  "Kstovo": "Кстово",
  "Zaozyorny": "Заозёрный",
  "Vidyayevo": "Видяево",
  "Lytkarino": "Лыткарино",
  
  "Lodeynoye Pole": "Лодейное Поле",
  "Bugulma": "Бугульма",
  "Konstantinovo": "Константиново",
  "Monchegorsk": "Мончегорск",
  "Dedovichi": "Дедовичи",
  "Pomryaskino": "Помряскино",
  "Meleuz": "Мелеуз",
  "Slavyansk-na-Kubani": "Славянск-на-Кубани",
  "Iudino": "Юдино",
  "Artyom": "Артём",
  "Abinsk": "Абинск",
  "Tarko-Sale": "Тарко-Сале",
  "Khimki": "Химки",
  "Nakhabino": "Нахабино",
  "Severomorsk": "Североморск",
  "Novomoskovsk": "Новомосковск",
  "Nyagan": "Нягань",
  "Dorogomilovo": "Дорогомилово",
  "Pereyaslavka": "Переяславка",
  "Bugry": "Бугры",
  "Novopavlovsk": "Новопавловск",
  "Odintsovo": "Одинцово",
  "Priozersk": "Приозерск",
  "Polyana": "Поляна",
  "Gusinoozyorsk": "Гусиноозёрск",
  "Apatity": "Апатиты",
  "Vershino-Darasunskiy": "Вершино-Дарасунский",
  "Lys'va": "Лысьва",
  "Plast": "Пласт",
  "Noyabrsk": "Ноябрьск",
  "Bolotnoye": "Болотное",
  "Komsomol'sk": "Комсомольск",
  "Cherkessk": "Черкесск",
  "Achinsk": "Ачинск",
  "Nizhneangarsk": "Нижнеангарск",
  "Stantsionnyy-Polevskoy": "Станционный-Полевской",
  "Kirensk": "Киренск",
  "Izberbash": "Избербаш",
  "Zdravnitsa": "Здравница",
  "Nizhneudinsk": "Нижнеудинск",
  "Naro-Fominsk": "Наро-Фоминск",
  "Tomilino": "Томилино",
  "Buy": "Буй",
  "Karabanovo": "Карабаново",
  "Ul'kan": "Улькан",
  "Novoaleksandrovsk": "Новоалександровск",
  "Baltiysk": "Балтийск",
  "Gora Sinyushina": "Гора Синюшина",
  "Sibay": "Сибай",
  "Reftinskiy": "Рефтинский",
  "Magistral'nyy": "Магистральный",
  "Primorsko-Akhtarsk": "Приморско-Ахтарск",
  "Chusovoy": "Чусовой",
  "Nebyloye": "Небылое",
  "Zhavoronki": "Жаворонки",
  "Dorokhovo": "Дорохово",
  "Yakshino": "Якшино",
  "Furmanov": "Фурманов",
  "Valuyki": "Валуйки",
  "Minusinsk": "Минусинск",
  "Dalnegorsk": "Дальнегорск",
  "Novotitarovskaya": "Новотитаровская",
  "Kotlas": "Котлас",
  "Kochubey": "Кочубей",
  "Tobolsk": "Тобольск",
  "Korocha": "Короча",
  "Belyy": "Белый",
  "Pridneprov'ye": "Приднепровье",
  "Sredneuralsk": "Среднеуральск",
  "Artyomovskiy": "Артёмовский",
  "Gavrilov-Yam": "Гаврилов-Ям",
  "Topki": "Топки",
  "Vozhega": "Вожега",
  "Zelenogorsk": "Зеленогорск",
  "Strunino": "Струнино",
  "Staronizhestebliyevskaya": "Старонижестеблиевская",
  "Uzlovoye": "Узловое",
  "Buguruslan": "Бугуруслан",
  "Vilyuchinsk": "Вилючинск",
  "Donskoy": "Донской",
  "Zhilino": "Жилино",
  "Aramil": "Арамиль",
  "Yasnogorsk": "Ясногорск",
  "Ustyuzhna": "Устюжна",
  "Velikiye Luki": "Великие Луки",
  "Krasnyy Bor": "Красный Бор",
  "Mukhor-Shibir'": "Мухор-Шибирь",
  "Mekhel'ta": "Мехельта",
  "Oktyabr'skiy": "Октябрьский",
  "Svetlyy": "Светлый",
  "Vyselki": "Выселки",
  "Ilanskiy": "Иланский",
  "Zheleznovodsk": "Железноводск",
  "Elektrogorsk": "Электрогорск",
  "Smolenka": "Смоленка",
  "Svetlograd": "Светлоград",
  "Sestroretsk": "Сестрорецк",
  "Saraktash": "Саракташ",
  "Gatchina": "Гатчина",
  "Kopeysk": "Копейск",
  "Lermontov": "Лермонтов",
  "Zernograd": "Зерноград",
  "Sargazy": "Саргазы",
  "Sheksna": "Шексна",
  "Protvino": "Протвино",
  "Galich": "Галич",
  "Blagovar": "Благовар",
  "Konosha": "Коноша",
  "Sel'tso": "Сельцо",
  "Dzerzhinskiy": "Дзержинский",
  "Chaltyr": "Чалтырь",
  "Gavrilov Posad": "Гаврилов Посад",
  "Kogalym": "Когалым",
  "Tsarskoye Selo": "Царское Село",
  "Martyush": "Мартюш",
  "Kushelevka": "Кушелевка",
  "Kalach-na-Donu": "Калач-на-Дону",
  "Verkhnyaya Pyshma": "Верхняя Пышма",
  "Lapshaur": "Лапшаур",
  "Troitsk": "Троицк",
  "Elektrostal": "Электросталь",
  "Rodniki": "Родники",
  "Kol'chugino": "Кольчугино",
  "Serov": "Серов",
  "Mogoytuy": "Могойтуй",
  "Sosenskiy": "Сосенский",
  "Ivangorod": "Ивангород",
  "Bikin": "Бикин",
  "Afipskiy": "Афипский",
  "Emmaus": "Эммаус",
  "Yessentukskaya": "Ессентукская",
  "Priyutovo": "Приютово",
  "Michurinsk": "Мичуринск",
  "Spitsevka": "Спицевка",
  "Gorodets": "Городец",
  "Klintsy": "Клинцы",
  "Naryan-Mar": "Нарьян-Мар",
  "Zadonsk": "Задонск",
  "Sayanogorsk": "Саяногорск",
  "Talovka": "Таловка",
  "Khot'kovo": "Хотьково",
  "Karabulak": "Карабулак",
  "Fryanovo": "Фряново",
  "Orel-Izumrud": "Орёл-Изумруд",
  "Rubilovo": "Рубилово",
  "Dmitriyevka": "Дмитриевка",
  "Morozovsk": "Морозовск",
  "Aban": "Абан",
  "Kirzhach": "Киржач",
  "Sukhinichi": "Сухиничи",
  "Gusev": "Гусев",
  "Divnogorsk": "Дивногорск",
  "Liski": "Лиски",
  "Korenovsk": "Кореновск",
  "Tayturka": "Тайтурка",
  "Argayash": "Аргаяш",
  "Petushki": "Петушки",
  "Izobil'nyy": "Изобильный",
  "Sverdlovskiy": "Свердловский",
  "Gorin": "Горин",
  "Gubakha": "Губаха",
  "Tavda": "Тавда",
  "Volkhov": "Волхов",
  "Gus'-Khrustal'nyy": "Гусь-Хрустальный",
  "Desnogorsk": "Десногорск",
  "Belebey": "Белебей",
  "Vanino": "Ванино",
  "Rubtsovsk": "Рубцовск",
  "Novoshakhtinsk": "Новошахтинск",
  "Konakovo": "Конаково",
  "Vikhorevka": "Вихоревка",
  "Dagestan": "Дагестан",
  "Mikheyevo": "Михеево",
  "Korkino": "Коркино",
  "Lempiny": "Лемпины",
  "Sofrino": "Софрино",
  "Krasnoarmeysk": "Красноармейск",
  "Myski": "Мыски",
  "Korkmaskala": "Коркмаскала",
  "Kropotkin": "Кропоткин",
  "Bogorodsk": "Богородск",
  "Aleysk": "Алейск",
  "Neryungri": "Нерюнгри",
  "Lensk": "Ленск",
  "Ust'-Kut": "Усть-Кут",
  "Uzhur": "Ужур",
  "Bykovka": "Быковка",
  "Apsheronsk": "Апшеронск",
  "Krasnogorskiy": "Красногорский",
  "Zheleznovodskiy": "Железноводский",
  "Zhigulevsk": "Жигулёвск",
  "Vidnoye": "Видное",
  "Novotroitsk": "Новотроицк",
  "Uvarovo": "Уварово",
  "Pikalyovo": "Пикалёво",
  "Neftegorsk": "Нефтегорск",
  "Donetsk": "Донецк",
  "Aktanysh": "Актаныш",
  "Simferopol": "Симферополь",
  "Saltykovka": "Салтыковка",
  "Ekazhevo": "Экажево",
  "Zvenigorod": "Звенигород",
  "Turukhansk": "Туруханск",
  "Russkiy Pervyy": "Русский Первый",
  "Malakhovka": "Малаховка",
  "Langepas": "Лангепас",
  "Omutninsk": "Омутнинск",
  "Pionerskiy": "Пионерский",
  "Zamoskvorech'ye": "Замоскворечье",
  "Kalinino": "Калинино",
  "Kirovsk": "Кировск",
  "Revda": "Ревда",
  "Sarov": "Саров",
  "Nizhnyaya Tura": "Нижняя Тура",
  "Bodaybo": "Бодайбо",
  "Kamenka": "Каменка",
  "Mordovo": "Мордово",
  "Kushva": "Кушва",
  "Poltakov": "Полтаков",
  "Pyt-Yakh": "Пыть-Ях",
  "Chernogolovka": "Черноголовка",
  "Kambarka": "Камбарка",
  "Velsk": "Вельск",
  "Uray": "Урай",
  "Staraya Kupavna": "Старая Купавна",
  "Zaraysk": "Зарайск",
  "Komintern": "Коминтерн",
  "Konchezero": "Кончезеро",
  "Petrov Val": "Петров Вал",
  "Udomlya": "Удомля",
  "Mariinsk": "Мариинск",
  "Nemchinovka": "Немчиновка",
  "Murom": "Муром",
  "Oktyabr'skoye": "Октябрьское",
  "Mikhaylovsk": "Михайловск",
  "Kuznetsk": "Кузнецк",
  "Dimitrovgrad": "Димитровград",
  "Krasnovishersk": "Красновишерск",
  "Lozhki": "Ложки",
  "Yutaza": "Ютаза",
  "Koryazhma": "Коряжма",
  "Kuchuk": "Кучук",
  "Nogliki": "Ноглики",
  "Belorechensk": "Белореченск",
  "Turochak": "Турочак",
  "Blagoveshchenka": "Благовещенка",
  "Birsk": "Бирск",
  "Novokubansk": "Новокубанск",
  "Kurchatov": "Курчатов",
  "Dobryanka": "Добрянка",
  "Yartsevo": "Ярцево",
  "Smidovich": "Смидович",
  "Krymsk": "Крымск",
  "Mayskiy": "Майский",
  "Serdobsk": "Сердобск",
  "Uyemskiy": "Уемский",
  "Chulym": "Чулым",
  "Pavlovskaya": "Павловская",
  "Sharypovo": "Шарыпово",
  "Mokshan": "Мокшан",
  "Satka": "Сатка",
  "Tuapse": "Туапсе",
  "Kimry": "Кимры",
  "Knyaginino": "Княгинино",
  "Fokino": "Фокино",
  "Zagorskie Dali": "Загорские Дали",
  "Privolzhsk": "Приволжск",
  "Salavat": "Салават",
  "Zherdevka": "Жердевка",
  "Volgorechensk": "Волгореченск",
  "Yegor'yevsk": "Егорьевск",
  "Neman": "Неман",
  "Yablonevka": "Яблоневка",
  "Alatyr'": "Алатырь",
  "Istra": "Истра",
  "Yashkino": "Яшкино",
  "Achit": "Ачит",
  "Khorol": "Хороль",
  "Raduzhny": "Радужный",
  "Nerekhta": "Нерехта",
  "Vyksa": "Выкса",
  "Chaykovskiy": "Чайковский",
  "Bataysk": "Батайск",
  "Batamay": "Батамай",
  "Bol'shaya Lavrovka": "Большая Лавровка",
  "Slavyanka": "Славянка",
  "Rybinsk": "Рыбинск",
  "Strezhevoy": "Стрежевой",
  "Kargopol'": "Каргополь",
  "Gelendzhik": "Геленджик",
  "Novoaltaysk": "Новоалтайск",
  "Zainsk": "Заинск",
  "Sovetsk": "Советск",
  "Borovichi": "Боровичи",
  "Rayevskiy": "Раевский",
  "Krasnokamsk": "Краснокамск",
  "Yelabuga": "Елабуга",
  "Lobanovo": "Лобаново",
  "Gur'yevsk": "Гурьевск",
  "Vyrubovo": "Вырубово",
  "Sovetskiy": "Советский",
  "Solnechnyy": "Солнечный",
  "Blagodarnyy": "Благодарный",
  "Buzuluk": "Бузулук",
  "Pozarikha": "Позариха",
  "Mozhga": "Можга",
  "Bulgakovo": "Булгаково",
  "Iskitim": "Искитим",
  "Lipin Bor": "Липин Бор",
  "Olonki": "Олонки",
  "Uchaly": "Учалы",
  "Dubrovka": "Дубровка",
  "Venyukovo": "Венюково",
  "Anzhero-Sudzhensk": "Анжеро-Судженск",
  "Nadym": "Надым",
  "Semenovka": "Семеновка",
  "Kommunar": "Коммунар",
  "Guryevsk": "Гурьевск",
  "Starotitarovskaya": "Старотитаровская",
  "Arsent'yevka": "Арсентьевка",
  "Shuya": "Шуя",
  "Shchigry": "Щигры",
  "Leningradskaya": "Ленинградская",
  "Novlyanka": "Новлянка",
  "Georgiyevka": "Георгиевка",
  "Vyazniki": "Вязники",
  "Digora": "Дигора",
  "Unecha": "Унеча",
  "Kirgiz-Miyaki": "Киргиз-Мияки",
  "Kirovgrad": "Кировград",
  "Pavlovskiy": "Павловский",
  "Primorsk": "Приморск",
  "Chernyanka": "Чернянка",
  "Shagonar": "Шагонар",
  "Chekhov": "Чехов",
  "Chapayevsk": "Чапаевск",
  "Volkhovskiy": "Волховский",
  "Arsen'yev": "Арсеньев",
  "Volzhsk": "Волжск",
  "Taksimo": "Таксимо",
  "Nerl'": "Нерль",
  "Tynda": "Тында",
  "Balykcha": "Балыкча",
  "Ivanteyevka": "Ивантеевка",
  "Kuznetskiy Rayon": "Кузнецкий район",
  "Alapayevsk": "Алапаевск",
  "Zheleznogorsk-Ilimskiy": "Железногорск-Илимский",
  "Nikol'sk": "Никольск",
  "Redkino": "Редкино",
  "Aprelevka": "Апрелевка",
  "Inta": "Инта",
  "Kostomuksha": "Костомукша",
  "Mikhaylovka": "Михайловка",
  "Mutsalaul": "Мутсалаул",
  "Birobidzhan": "Биробиджан",
  "Dzhalil'": "Джалиль",
  "Pargolovo": "Парголово",
  "Tatsinskiy": "Тацинский",
  "Pelagiada": "Пелагиада",
  "Novovarshavka": "Нововаршавка",
  "Ishim": "Ишим",
  "Novaya Gollandiya": "Новая Голландия",
  "Stupino": "Ступино",
  "Krasnokamensk": "Краснокаменск",
  "Kazankovo": "Казанково",
  "Krasnozavodsk": "Краснозаводск",
  "Novaya Chara": "Новая Чара",
  "Klimovsk": "Климовск"
}
